import { z } from 'zod';
import { ExternalContactSchema } from '../../entities/external-contact/external-contact.schema';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Update External Contact Request Schema
 * PATCH /api/v2/external-contacts/:id
 */ export const UpdateExternalContactRequestSchema = z.object({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    // null = clear the stored email (server translates to $unset).
    email: z.string().email(ErrorCode.FIELD_INVALID_EMAIL).nullable().optional(),
    description: z.string().optional(),
    type: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional()
});
/**
 * Update External Contact Response Schema
 * PATCH /api/v2/external-contacts/:id
 */ export const UpdateExternalContactResponseSchema = z.object({
    data: ExternalContactSchema
});

//# sourceMappingURL=update-external-contact.schema.js.map